import { ImportData, InternalColumns } from 'features/importerv2/importer-types'

/**
 * Returns a new ImportData with the value of `field` updated for the row
 * identified by `rowId`. All other rows are left untouched (immutable).
 *
 * Pure helper — no side effects, no React, no dispatch.
 */
export function setCellByRowId(
  data: ImportData,
  rowId: string,
  field: string,
  value: string
): ImportData {
  return {
    ...data,
    rows: data.rows.map((row) =>
      row[InternalColumns.ROW_ID] === rowId ? { ...row, [field]: value } : row
    ),
  }
}
